import { useEffect, useRef } from "react";
import { Loader2 } from "lucide-react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { ListingCard } from "@/components/ListingCard";
import { useCachedGet } from "@/lib/cache";
import { useLang } from "@/context/LanguageContext";
import { useAuth } from "@/context/AuthContext";

export default function Favorites() {
  const { t } = useLang();
  const { user } = useAuth();
  const { data, loading, reload } = useCachedGet("/favorites");
  const favIds = user?.favorites || [];
  const items = (data || []).filter((l) => favIds.includes(l.id));
  const favKey = favIds.length;
  const first = useRef(true);
  useEffect(() => { if (first.current) { first.current = false; return; } reload(); }, [favKey, reload]);

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="max-w-7xl 2xl:max-w-[1600px] mx-auto px-4 sm:px-8 w-full py-10 flex-1">
        <h1 className="font-headline text-2xl sm:text-3xl font-bold mb-6">{t("fav_title")}</h1>
        {loading ? (
          <div className="flex justify-center py-20"><Loader2 className="w-8 h-8 animate-spin text-primary" /></div>
        ) : items.length === 0 ? (
          <div className="text-center py-20 text-slate-500" data-testid="favorites-empty">{t("fav_empty")}</div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-4 gap-5" data-testid="favorites-grid">{items.map((l) => <ListingCard key={l.id} listing={l} />)}</div>
        )}
      </main>
      <Footer />
    </div>
  );
}
